<template>
  <div>
    <b-container>
      <form class="form-signin" @submit.prevent="login">
        <h3 class="text-center">Please sign in</h3>
        <label for="inputUsername" class="sr-only">Username</label>
        <input
          v-model="username"
          type="text"
          id="inputUsername"
          class="form-control"
          placeholder="Username"
          required
          autofocus
        />
        <label for="inputPassword" class="sr-only">Password</label>
        <input
          v-model="password"
          type="password"
          id="inputPassword"
          class="form-control"
          placeholder="Password"
          required
        />
        <div class="mb-4"></div>
        <button class="btn btn-lg btn-danger btn-block" type="submit">
          Sign in
        </button>
      </form>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import "axios-response-logger";
import { mixins } from "../mixins";

export default {
  name: "login",
  mixins: [mixins],
  data() {
    return {
      username: null,
      password: null,
    };
  },
  methods: {
    login() {
      axios({
        url: process.env.VUE_APP_API_BASE + "/login",
        method: "post",
        timeout: 1000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/jwt",
        },
        data: {
          username: this.username,
          password: this.password,
        },
      })
        .then(async (response) => {
          await this.$store.dispatch("setJWT", { jwt: response.data });
          let user = await this.$store.getters.user;
          await this.successToast("Welcome " + JSON.stringify(user));
          this.$router.push({
            path: "/",
          });
        })
        .catch((error) => {
          this.errorToast("ERROR" + error.message || "Error Authenticting");
          this.$store.dsipatch("setJWT", undefined);
        });
    },
  },
};
</script>

<style scoped>
.form-signin {
  width: 100%;
  max-width: 350px;
  padding: 15px;
  margin: 0 auto;
}
.form-signin input[type="text"] {
  margin-bottom: -1px !important;
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
@media (prefers-color-scheme: dark) {
  h3 {
    color: #fff !important;
  }
}
</style>
